import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  name: 'server-not-found',
  data() {
    return {}
  },
  components: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  methods: {
    ...mapActions({}),
    ...mapMutations({}),
    fuion(data) {},
  },
  destroyed() {},
}
